import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import {
  StatsSection,
  FeaturesSection,
  TestimonialsSection,
  DataProtectionSection,
  PricingSection,
  CookieConsent,
} from '../components/landing';
import { HeroSectionV2 } from '../components/landing-v2/HeroSectionV2';
import { ProcessSectionV2 } from '../components/landing-v2/ProcessSectionV2';
import { InterviewSectionV2 } from '../components/landing-v2/InterviewSectionV2';
import { ContactSectionV2 } from '../components/landing-v2/ContactSectionV2';
import { KickerCapture } from '../components/landing/KickerCapture';
import { scrollToLandingHashWhenReady } from '../utils/landingNav';

/**
 * LandingPage — the canonical marketing landing. Uses the V2 hero / process /
 * interview / contact sections (formerly /welcome) since we settled on that
 * variant. /welcome now redirects here.
 */
export const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    return scrollToLandingHashWhenReady(location.hash);
  }, [location.hash]);

  return (
    <Layout className="min-h-screen bg-white flex flex-col" hideHeader={true} fullPage>
      <HeroSectionV2 />
      <StatsSection />
      <FeaturesSection />
      <ProcessSectionV2 />
      <InterviewSectionV2 />
      <TestimonialsSection />
      <DataProtectionSection />
      <div>
        <PricingSection />
      </div>
      <ContactSectionV2 />
      <KickerCapture />
      <CookieConsent />
    </Layout>
  );
};

export default LandingPage;
